import React from 'react';
import {useMyUserId} from '../../data/hooks/sessionHooks';
import getUserFromMeetingInvite from '../../misc/getUserFromMeetingInvite';

const MeetingName = props => {
    const {meeting, i18n} = props,
        myUserId = useMyUserId(),
        otherUser = meeting.initiator.id == myUserId ? getUserFromMeetingInvite(meeting.invited[0], i18n) : meeting.initiator;

    return otherUser.first_name + ' ' + otherUser.last_name;
};

export default MeetingName;
